import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import UserGroupsPanelNarrow from '../containers/UserGroupsPanelNarrow';
import UserGroupsPanelFull from '../containers/UserGroupsPanelFull';

const UserGroupsPanel = ({ configuration }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: UserGroupsPanelFull, narrow: UserGroupsPanelNarrow }}
  />
);

export default UserGroupsPanel;
